import React, {useRef, useState, useEffect} from 'react';
import {useSelector } from 'react-redux';
import {createSelector} from 'reselect';
import ButtonLoader from '../../../../../../../../onboarding/src/stories/components/UI/Loader/Loader';

import * as S from './AadharOtpVerify.styles';

import OTPBlock from '../../../../../../../../onboarding/src/stories/components/UI/OTP/otp';

const AadharOtpVerify = ({closeModal, submitOtp, errorText, resentOtp, clickActive}) => {

    const otpRef = useRef(null);
    let isLoading = useSelector(createSelector((state) => state?.user || {}, item => item?.isLoading || false))

    const submitUserOtp = (event: React.FormEvent) => {
        event.preventDefault();
        const otpStr = otpRef.current.value;
        submitOtp(otpStr);
    }

    return(
        <S.OtpPopUpOverlay>
            <S.OtpPopUpBlock>
                <S.OtpPopHead>
                    <S.OtpPopHeadText>Please enter OTP</S.OtpPopHeadText>
                </S.OtpPopHead>
                <S.OtpPopBodyWrap>
                    <S.AadharForm onSubmit={submitUserOtp}>
                        <S.OtpWrapper >
                            <S.OtpInfoText>Please enter the OTP sent on your registered mobile number with your Aadhar Number</S.OtpInfoText>
                            <OTPBlock
                                ref={otpRef}
                                label=""
                                subLabel=""
                                otpLength={6}
                                type="aadhar_number"
                                resendOTP = {() => resentOtp()}
                                autoFocus={true}
                                resendVisible={clickActive}
                            />
                            {(errorText && <S.ErrorText>{errorText}</S.ErrorText>) || null}
                        </S.OtpWrapper>
                        <S.OtpFooterBtnWrap>
                            <S.CancelBtn onClick={closeModal}>Cancel</S.CancelBtn>
                            <S.SubmitBtn type="submit">{isLoading ? <ButtonLoader loaderType="button"/> : 'Submit'}</S.SubmitBtn>
                        </S.OtpFooterBtnWrap>
                    </S.AadharForm>
                </S.OtpPopBodyWrap>
            </S.OtpPopUpBlock>
        </S.OtpPopUpOverlay>
    );
}

export default AadharOtpVerify;